export default __webpack_public_path__ + "static/media/menu.3dd45816.svg";